import React, { useCallback, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ReportCurrency } from '../../../models';
import * as Styled from './styled';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingPercentageRentProps {
  onChange: (updatedValue: ReportSettingPercentageRentState) => void;
  reportSettingState: ReportSettingPercentageRentState;
}

export interface ReportSettingPercentageRentState {
  selectedCurrency: SelectOption<ReportCurrency>;
  fromDate: string;
  toDate: string;
  isValid: boolean;
}

function ReportSettingPercentageRent({
  onChange,
  reportSettingState,
}: ReportSettingPercentageRentProps): JSX.Element {
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                onChange({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [onChange, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingPercentageRent);
